import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { useState } from "react";
import { IAddOrInviteResellerClientParams } from "../../../clients/answeringClient";

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  error?: string;
  onClose: () => void;
  onConfirm: (data: IAddOrInviteResellerClientParams) => void;
}

export function AddClientModal({
  isOpen,
  isLoading,
  error,
  onClose,
  onConfirm,
}: Props) {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const handleConfirm = () => {
    if (email && firstName && lastName) {
      onConfirm({ email, firstName, lastName });
      setEmail("");
      setFirstName("");
      setLastName("");
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth variant="modal">
      <DialogTitle variant="modal">
        <PersonAddAltIcon />
        Adicionar Novo Cliente
      </DialogTitle>
      <DialogContent variant="modal">
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Digite os dados do cliente. Se ele não tiver uma conta, um convite será enviado.
        </Typography>

        {isLoading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              fullWidth
              required
              label="Nome do Cliente"
              variant="outlined"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <TextField
              fullWidth
              required
              label="Sobrenome do Cliente"
              variant="outlined"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <TextField
              fullWidth
              required
              label="E-mail do Cliente"
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value.trim())}
              error={!!error}
              helperText={error}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions
        variant="modal"
        sx={{ justifyContent: "end", flexWrap: "wrap", gap: 1, mt: 1 }}
      >
        <Button variant="outlined" color="error" onClick={onClose}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={!email || isLoading}
        >
          Adicionar Cliente
        </Button>
      </DialogActions>
    </Dialog>
  );
}
